import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { config as configs } from "config";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN_URL,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),

    Sentry.feedbackIntegration({
      colorScheme: "system",
    }),

    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: true,
      networkDetailAllowUrls: ["*"],
      networkRequestHeaders: ["*"],
      networkResponseHeaders: ["*"],
    }),
  ],
  enabled: configs.NODE_ENV === "production",
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["*"],
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  attachStacktrace: true,
  sendDefaultPii: true,
});
